import { useCallback, useState } from "react";

import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

import Grid from "@mui/material/Grid";
import LoadingButton from "@mui/lab/LoadingButton";

import { useAsync } from "../../../hooks/useAsync";

import useEquipmentService from "../../../services/equipmentService";

import DateField from "../../field/DateField/DateField";
import AutocompleteField from "../../field/AutocompleteField";
import BasicDialog from "../../base/BasicDialog";

import { useForm } from "../../../hooks/useForm";
import DateService from "../../../services/dateService";

import useLocationService from "../../../services/locationService";

const ElectricityDistributionSymfoniaDialog = (props) => {
  const { t } = useTranslation();

  const {
    formValue,
    onChangeDate,
    onChangeAutocompleteFieldWithObjectOptions,
  } = useForm({});

  const [genereting, setGenereting] = useState(false);

  const { getElectricityDistributionSymfoniaReport } = useEquipmentService();
  const { getObjectSelectList } = useLocationService();

  const objectSelectList = useAsync(() =>
    getObjectSelectList({
      object_level: 2,
      parent__object_name: "Olivia Centre",
    })
  );

  const prepareDataToSend = () => {
    return {
      year: DateService.getYearFromDateStr(formValue.year_month),
      month: DateService.getMonthFromDateStr(formValue.year_month),
      object_level_2: formValue.object_level_2,
    };
  };

  const onClickGenerate = useCallback(() => {
    setGenereting(true);
    getElectricityDistributionSymfoniaReport(
      prepareDataToSend(),
      setGenereting
    );
  });

  const getDialogContent = () => {
    return (
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        spacing={1}
      >
        <Grid item xs={12} sm={6}>
          <DateField
            name={"year_month"}
            label={t("month")}
            value={formValue.year_month}
            onChange={onChangeDate}
            showClearIcon={false}
            required
            view={"month"}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <AutocompleteField
            name="object_level_2"
            multiple={false}
            isObjectOption={true}
            optionLabelKey={"object_name"}
            value={formValue.object_level_2}
            options={
              objectSelectList.value
                ? objectSelectList?.value.sort((a, b) =>
                    a.object_name > b.object_name ? 1 : -1
                  )
                : []
            }
            label={t("bar.offer_chart_bar.object_level_2")}
            onChange={onChangeAutocompleteFieldWithObjectOptions}
            required
          />
        </Grid>
        <Grid item xs={12}>
          <LoadingButton
            fullWidth
            variant="contained"
            color="primary"
            loading={genereting}
            onClick={onClickGenerate}
            disabled={!(formValue.year_month && formValue.object_level_2)}
          >
            {t("download")}
          </LoadingButton>
        </Grid>
      </Grid>
    );
  };

  return (
    <BasicDialog
      open={props.open}
      onClose={props.onClose}
      titleAlign="center"
      title={t("dialog.equipment.electricity_distribution_symfonia_report")}
      maxWidth={"sm"}
      showTopFullScreenButton={false}
    >
      {getDialogContent()}
    </BasicDialog>
  );
};

ElectricityDistributionSymfoniaDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

ElectricityDistributionSymfoniaDialog.defaultProps = {};

export default ElectricityDistributionSymfoniaDialog;
